import { FC } from 'react';
import { Tooltip, Typography } from '@mui/material';

interface TruncatedTextWithTooltipProps {
  text: string;
  maxLength?: number;
}

const TruncatedTextWithTooltip: FC<TruncatedTextWithTooltipProps> = ({
  text,
  maxLength = 50,
}) => {
  if (!text) {
    return null;
  }

  const isTruncated = text.length > maxLength;
  const displayText = isTruncated ? `${text.slice(0, maxLength)}...` : text;

  return (
    <Tooltip title={text} arrow>
      <Typography variant="body2">{displayText}</Typography>
    </Tooltip>
  );
};

export default TruncatedTextWithTooltip;
